import { useState } from "react";
import { ExternalLink, Video } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { JitsiMeeting } from "./JitsiMeeting";

const JITSI_DOMAIN = process.env.REACT_APP_JITSI_DOMAIN || "meet.jit.si";

export function VideoCallButton({ projectId, label = "Anruf", testid = "video-call-button", className = "" }) {
  const [open, setOpen] = useState(false);
  const [room, setRoom] = useState(null);
  const [loading, setLoading] = useState(false);

  const join = async () => {
    setLoading(true);
    try {
      const res = projectId
        ? await api.post("/rooms/project", { project_id: projectId })
        : await api.get("/rooms/team");
      setRoom(res.data);
      setOpen(true);
    } catch (e) {
      toast.error(errMsg(e, "Videoanruf konnte nicht gestartet werden"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        data-testid={testid}
        onClick={join}
        disabled={loading}
        variant="outline"
        className={`rounded-xl ${className}`}
      >
        <Video className="mr-1.5 h-4 w-4" /> {loading ? "Verbinde…" : label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[95vw] max-w-6xl rounded-2xl p-4" data-testid="video-call-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-lg text-[#1D225C]">
              {projectId ? "Projekt-Videoanruf" : "Team-Videoanruf"}
            </DialogTitle>
          </DialogHeader>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="max-w-xl text-xs text-[#777]">
              Beide treten über den Anruf-Button demselben Raum bei. Hinweis: Wer die Konferenz als Erster startet,
              klickt einmalig auf „Ich leite die Konferenz" (kostenlose Anmeldung, z. B. per Google) – danach kann
              der andere jederzeit ohne Konto beitreten. Mikrofon, Kamera und Bildschirmfreigabe unten in der Leiste.
            </p>
            {room && (
              <a
                data-testid="video-call-external-link"
                href={`https://${JITSI_DOMAIN}/${room.roomName}`}
                target="_blank"
                rel="noreferrer"
                className="flex shrink-0 items-center gap-1 text-xs font-semibold text-[#B88A4A] hover:underline"
              >
                <ExternalLink className="h-3.5 w-3.5" /> In neuem Tab öffnen
              </a>
            )}
          </div>
          {room && (
            <div className="h-[72vh]">
              <JitsiMeeting roomName={room.roomName} displayName={room.displayName} onLeave={() => setOpen(false)} />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
